import { useMutation } from '@tanstack/react-query';

import { message } from 'antd';

import Api from '@app/services/api';
import { useApiErrorMessage } from '@app/services/hooks/useApiErrorMessage';

interface IProps {
  order_import_uid: string;
}

export const useCreateOrders = () => {
  const getErrorMessage = useApiErrorMessage();

  return useMutation({
    mutationFn: async ({ order_import_uid }: IProps) => {
      return await Api.orders.postCreateOrders(order_import_uid);
    },
    onError: (err) => {
      message.open({
        type: 'error',
        content: getErrorMessage(err),
      });
    },
    onSuccess: async (data) => {
      return data;
    },
  });
};
